module.exports = __webpack_public_path__ + "static/img/land_text.4fa6b85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/land/land_text.png
// module id = xEXK
// module chunks = 1